/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon';
icon.register({
  'skill': {
    width: 128,
    height: 128,
    viewBox: '0 0 128 128',
    data: '<path pid="0" d="M31.7 93.2H65a41 41 0 0 0 5 6.8H31.7v-6.7zm0-10.6h28.9a44.8 44.8 0 0 1-1.3-6.7H31.7v6.7zm0-17.2h27.7c.3-2.3.7-4.6 1.3-6.7h-29v6.7zm53.9 44.8v5.8c0 2.8-2.1 5.1-4.7 5.1h-70c-2.6 0-4.7-2.3-4.7-5V31.2l23.2-21v22.3H17.2v6.6h18.4V6.7h45.3c2.6 0 4.7 2.3 4.7 5v20c2-.6 4-1 6.1-1.4V11.8C91.7 5.3 87 0 81 0H31.1L0 28.1v88c0 6.4 4.9 11.7 10.8 11.7H81c6 0 10.8-5.3 10.8-11.8v-4.4c-2-.3-4.1-.7-6.1-1.4zM23.3 58.7h-8v6.7h8v-6.7zm-8 41.2h8v-6.7h-8v6.7zm8-24h-8v6.7h8V76zM113 61l-4.9-4-12.4 17.5-11.2-9.3-3.8 5.3 16 13.4 16.3-23zm15 10c0-18.6-14-33.7-31.1-33.7-17.2 0-31.2 15.2-31.2 33.8 0 18.6 14 33.8 31.2 33.8C114 104.8 128 89.6 128 71zm-6.2 0c0 15-11.2 27.2-25 27.2-13.7 0-25-12.2-25-27.1 0-15 11.3-27.1 25-27.1 13.8 0 25 12.1 25 27z"/>'
  }
});